import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { RichText, useBlockProps } from '@wordpress/block-editor';
export default function save(_ref) {
  let {
    attributes
  } = _ref;
  const {
    ordered,
    values,
    type,
    reversed,
    start
  } = attributes;
  const TagName = ordered ? 'ol' : 'ul';
  return createElement(TagName, useBlockProps.save({
    type,
    reversed,
    start
  }), createElement(RichText.Content, {
    value: values,
    multiline: "li"
  }));
}
//# sourceMappingURL=save.js.map